import {
  getMinOrderQty,
  getPackQty,
  getCartonQty,
  getExtra1Qty,
  getExtra2Qty,
  getExtra3Qty,
} from "./purchaseOptions";

export const MAX_CART_QTY = 240000;

const getPurchaseStep = (purchaseType, product = {}) => {
      console.log("minorderqty", getMinOrderQty(product));

  switch (purchaseType) {

    case "piece": return getMinOrderQty(product);
    case "pack": return getPackQty(product);
    case "carton": return getCartonQty(product);
    case "extra1": return getExtra1Qty(product) || getMinOrderQty(product);
    case "extra2": return getExtra2Qty(product) || getMinOrderQty(product);
    case "extra3": return getExtra3Qty(product) || getMinOrderQty(product);
    default: return getMinOrderQty(product);
  }
};

export const getNextQty = (
  qty,
  stock,
  maxQty = MAX_CART_QTY,
  purchaseType = "piece",
  product = {},
) => {
  const currentQty = Number(qty) || 0;
  const availableStock = Number(stock) || 0;
  const limit = availableStock > 0 ? Math.min(availableStock, maxQty) : maxQty;

  let step = getPurchaseStep(purchaseType, product);
  if (!step || step <= 0) step = 1;
  return Math.min(currentQty + step, limit);
};

export const getPrevQty = (qty, minQty = 1, purchaseType = "piece", product = {}) => {
  const currentQty = Number(qty) || 0;
  const minimumQty = Number(minQty) || 1;

  let step = getPurchaseStep(purchaseType, product);
  if (!step || step <= 0) step = 1;
  return Math.max(currentQty - step, minimumQty);
};
